import { z } from 'zod';

import { KindOfResearchStudy, RespondentDashboardSort } from '@/api/core-api';
import { utmSearchSchema } from '@/schemas/utm';

// Extends the shared `utm_*` shape (`@/schemas/utm`) rather than a plain
// `z.object`: this is the redirect target for the advertised participant CTA
// (`/participants/` → `/participants/projects`), and an already-signed-in
// visitor lands here directly with no login page in between to capture the
// campaign params first. Admitting them keeps `Route.useSearch()` from
// silently dropping them so `useCaptureParticipantUtmFromSearch` can see
// them (PX-274).
export const projectsSearchSchema = utmSearchSchema.extend({
  // TanStack Router JSON-parses search params, so `?q=123` arrives as a
  // number — coerce so numeric queries don't crash schema validation.
  q: z.coerce.string().max(255).optional().catch(undefined),
  filter: z.array(z.enum(KindOfResearchStudy)).default([]),
  sort: z.enum(RespondentDashboardSort).default('publishedAt'),
  eligible: z.boolean().default(true),
});

export type ProjectsSearch = z.infer<typeof projectsSearchSchema>;
